






















































































import { beforeCurrentDateRule, dateRule } from "@/lib/rules/dateRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { CreateMeterReading } from "@/store/models/meter-reading";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { MeterReadingModule } from "@/store/modules/meter-reading.store";
import FileUploadMulti from "@/components/files/FileUploadMulti.vue";
import { isNumberRule } from "@/lib/rules/isNumberRule";
import { ChargingStationModule } from "@/store/modules/charging-station.store";

@Component({
  components: { FileUploadMulti }
})
export default class ThgMeterReadingForm extends Vue {
  @Prop()
  private chargingStationId!: string;

  meterReading = new CreateMeterReading();

  isLoading = false;
  valid = false;
  isDatepickerStartMenuActive = false;
  isDatepickerEndMenuActive = false;
  activePicker = "MONTH";

  multiSteps = {
    meterReadingProof: {
      example: AssetEnum.emptyData,
      overlay: AssetEnum.emptyData,
      text: "report.thgRegistration.registrationFront",
      textAlt: "report.thgRegistration.registrationFrontAlt",
      filesCb: MeterReadingModule.meterReadingProof,
      handleUpload: MeterReadingModule.addMeterReading,
      handleDelete: MeterReadingModule.removeMeterReadingProof
    }
  };

  instruction: IReportInstructionData = {
    title: "report.thgRegistration.title",
    text: "report.thgRegistration.instructionText",
    pictures: [AssetEnum.registrationCorrectInstructions, AssetEnum.registrationIncorrectInstructions],
    example: AssetEnum.registrationExample,
    display: true
  };

  get getMeterReadingProof() {
    return MeterReadingModule.meterReadingProof;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get numberRule() {
    return [isNumberRule(), requiredRule()];
  }

  get dateRule() {
    return [dateRule(), beforeCurrentDateRule()];
  }

  get currentYear() {
    return new Date(new Date().setFullYear(new Date().getFullYear(), 0, 1)).toISOString().substr(0, 10);
  }

  get chargingStationName() {
    return ChargingStationModule.activeChargingStation?.name || "";
  }

  save() {
    this.meterReading.meterReading.chargingStationId = this.chargingStationId;
    this.meterReading.meterReading.proof = MeterReadingModule.meterReadingProof.map(x => x.uploadId);
    this.$emit("save", this.meterReading);
  }

  async mounted() {
    this.isLoading = true;
    try {
      await ChargingStationModule.getChargingStation(this.chargingStationId);
    } catch (error) {
      this.$toast.error((error as any).message);
    } finally {
      this.isLoading = false;
    }
  }

  @Watch("isDatepickerStartMenuActive")
  menuStart(val: boolean) {
    return val && setTimeout(() => (this.activePicker = "MONTH"));
  }

  @Watch("isDatepickerEndMenuActive")
  menuEnd(val: boolean) {
    return val && setTimeout(() => (this.activePicker = "MONTH"));
  }
}
